"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormLabel = exports.FormHelperText = exports.FormGroup = exports.FormControlLabel = exports.FormControl = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var core_1 = require("@material-ui/core");
exports.FormControl = react_1.forwardRef(function FormControl(props, ref) {
    return jsx_runtime_1.jsx(core_1.FormControl, __assign({}, props, { ref: ref }), void 0);
});
exports.FormControlLabel = react_1.forwardRef(function FormControlLabel(props, ref) {
    return jsx_runtime_1.jsx(core_1.FormControlLabel, __assign({}, props, { ref: ref }), void 0);
});
exports.FormGroup = react_1.forwardRef(function FormGroup(props, ref) {
    return jsx_runtime_1.jsx(core_1.FormGroup, __assign({}, props, { ref: ref }), void 0);
});
var FormHelperText = function (props) { return (jsx_runtime_1.jsx(core_1.FormHelperText, __assign({}, props), void 0)); };
exports.FormHelperText = FormHelperText;
var FormLabel = function (props) { return jsx_runtime_1.jsx(core_1.FormLabel, __assign({}, props), void 0); };
exports.FormLabel = FormLabel;
//# sourceMappingURL=Form.js.map